// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2XJqK","consentsList":"PatientConsents_consentsList__3i4Rx","consentsListEmpty":"PatientConsents_consentsListEmpty__3e-jp"};